import { defineStore } from "pinia";
import { ref } from "vue";

import axios from "axios";

interface Offense {
    offense: string,
    code: string
}

export const useOffenseStore = defineStore("offenseStore", () => {
    const loading = ref(false);

    const items = ref<Offense[]>();

    const list = async (types: string) => {

        try {
            loading.value = true;
            const response = await axios.get<Offense[]>(`api/v1/audit/audits/offense?offenseCode=${types}`);
            items.value = response.data;
        }
        finally {
            loading.value = false;
        }
    }

    return { loading, list, items };
});